import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";
// tslint:disable
export const yammer_praise_money: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 150 150" id="yk-svg-praise-money" {...rest}>
      <title>praise-money</title>
      <circle fill="#84CA4B" cx="75" cy="75" r="75"></circle>
      <path
        fill="#495361"
        d="M89.1 48.8v-9l7.6-17c1.1-2.7-.8-5.7-3.8-5.7H59.6c-2.8 0-4.8 2.8-3.8 5.5l6.4 16.8v9c-18 9.6-33.9 37.1-33.9 50.8 0 16.7 21.6 30.3 48.2 30.3s48.2-13.6 48.2-30.3c0-13.5-17.2-40.4-35.6-50.4z"
      ></path>
      <path fill="#19345D" d="M62.2 39.8h26.9v8.6H62.2z"></path>
      <path
        fill="#FCD700"
        d="M92.3 92.9c-.9-1.6-2.1-2.9-3.5-4s-3-2-4.7-2.8c-1.6-.7-3.2-1.3-4.8-1.8V67.9c1.4 0 2.8.4 4.2 1 1.6.7 2.8 1.7 3.7 3.1l.4.6 5-4-.4-.5c-.7-.7-1.4-1.4-2.3-2.1s-1.8-1.3-2.9-1.9c-1.1-.5-2.3-1-3.7-1.3-1.2-.3-2.5-.4-4-.5v-4.4h-4.7v4.6c-1.6.2-3.2.6-4.7 1.1-1.7.7-3.2 1.6-4.5 2.7s-2.4 2.5-3.2 4.1-1.2 3.4-1.2 5.3c0 2.1.4 3.9 1.3 5.4.9 1.5 2 2.8 3.3 3.8 1.3 1 2.9 1.9 4.5 2.6 1.5.6 3 1.1 4.5 1.6v17.1c-.5 0-1.1-.1-1.7-.3-.9-.2-1.8-.6-2.7-1-.9-.5-1.8-1-2.7-1.7-.9-.7-1.7-1.4-2.4-2.3l-.4-.5-5.3 3.5.4.5c1.5 1.9 3.6 3.6 6.3 5 2.5 1.3 5.4 2.1 8.5 2.4v4.3h4.7v-4.5c1.9-.2 3.6-.6 5.2-1.2 1.8-.7 3.4-1.6 4.8-2.7s2.4-2.5 3.2-4.1c.8-1.6 1.2-3.3 1.2-5.2-.1-2-.5-4-1.4-5.5zm-5.1 5.7c0 1.5-.3 2.8-.9 3.7-.6 1-1.3 1.8-2.2 2.4-.8.6-1.8 1-2.8 1.3-.8.2-1.5.3-2.2.3V90.6c2.2.7 4.1 1.7 5.6 3 1.8 1.3 2.6 2.9 2.5 5zm-15-16.7c-1-.5-1.8-1-2.6-1.6-.7-.6-1.3-1.2-1.7-2-.4-.7-.6-1.6-.6-2.7 0-1 .2-2 .6-2.9s.9-1.7 1.6-2.4c.7-.7 1.5-1.2 2.5-1.7.8-.3 1.6-.6 2.5-.7v14.9c-.7-.2-1.5-.5-2.3-.9z"
      ></path>
    </svg>
  );
};
